export const STAFF = 'STAFF';
export const ROOMS = 'ROOMS';
export const EQUIPMENT = 'EQUIPMENT';
export const STAFF_WEEK = 'STAFF_WEEK';
